import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { DomesticTypes } from "@assets/types";
import DomesticService from "@services/DomesticService";
import { RootState } from "@state/store";

export const getDomesticItemConditions = createAsyncThunk(
  "domestic/getItemConditions",
  () => DomesticService.getItemConditions()
);

export const getDomesticPostCodes = createAsyncThunk(
  "domestic/getPostCodes",
  () => DomesticService.getPostCodes()
);

export interface DomesticState {
  itemConditions: DomesticTypes.DomesticItemCondition[];
  postCodes: DomesticTypes.DomesticPostCode[];
  isLoading: boolean;
}

export const initialDomesticState: DomesticState = {
  itemConditions: [],
  postCodes: [],
  isLoading: false,
};

export const domesticSlice = createSlice({
  name: "domestic",
  initialState: initialDomesticState,
  reducers: {},
  extraReducers: (builder) => {
    // Item conditions
    builder.addCase(getDomesticItemConditions.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getDomesticItemConditions.fulfilled,
      (state, action: PayloadAction<DomesticTypes.DomesticItemCondition[]>) => {
        state.isLoading = false;
        state.itemConditions = action.payload;
      }
    );
    builder.addCase(getDomesticItemConditions.rejected, (state) => {
      state.isLoading = false;
    });
    // Post codes
    builder.addCase(getDomesticPostCodes.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      getDomesticPostCodes.fulfilled,
      (state, action: PayloadAction<DomesticTypes.DomesticPostCode[]>) => {
        state.isLoading = false;
        state.postCodes = action.payload;
      }
    );
    builder.addCase(getDomesticPostCodes.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const domesticItemConditionsState = (state: RootState) =>
  state.domesticSlice.itemConditions;

export const domesticPostCodesState = (state: RootState) =>
  state.domesticSlice.postCodes;

export default domesticSlice.reducer;
